import { Col, Flex, Row, message } from "antd";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createImageCaptureAccount } from "./../../../../lib/api/resources/imageCaptureAccounts";
import { ImageCaptureAccountFormCard } from "./components/ImageCaptureAccountFormCard";

export const ImageCaptureAccountCreate = () => {
  const navigate = useNavigate();

  const createMutation = useMutation({
    mutationFn: async (data: any) => createImageCaptureAccount(data),
    onSuccess: () => {
      navigate("/image-captures/accounts");
      message.success("Account succesvol aangemaakt");
    },
    onError: () => {
      message.error(
        "Er is een fout opgetreden bij het aanmaken van het account",
      );
    },
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ImageCaptureAccountFormCard mutation={createMutation} />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
